import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CompleteM365MailboxConnectMutationVariables = Types.Exact<{
  input: Types.CompleteM365MailboxConnectInput;
}>;


export type CompleteM365MailboxConnectMutation = { __typename?: 'Mutation', completeM365MailboxConnect: { __typename?: 'M365MailboxConnectPayload', status?: { __typename?: 'M365MailboxStatus', connected: boolean, grantsSendScope: boolean, mailboxAddress?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DisconnectM365MailboxMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisconnectM365MailboxMutation = { __typename?: 'Mutation', disconnectM365Mailbox: { __typename?: 'M365MailboxConnectPayload', status?: { __typename?: 'M365MailboxStatus', connected: boolean, grantsSendScope: boolean, mailboxAddress?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CompleteM365MailboxConnectDocument = new TypedDocumentString(`
    mutation CompleteM365MailboxConnect($input: CompleteM365MailboxConnectInput!) {
  completeM365MailboxConnect(input: $input) {
    status {
      ...M365MailboxStatus
    }
    errors {
      code
      message
    }
  }
}
    fragment M365MailboxStatus on M365MailboxStatus {
  connected
  grantsSendScope
  mailboxAddress
}`);
export const DisconnectM365MailboxDocument = new TypedDocumentString(`
    mutation DisconnectM365Mailbox {
  disconnectM365Mailbox {
    status {
      ...M365MailboxStatus
    }
    errors {
      code
      message
    }
  }
}
    fragment M365MailboxStatus on M365MailboxStatus {
  connected
  grantsSendScope
  mailboxAddress
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CompleteM365MailboxConnect: build.mutation<CompleteM365MailboxConnectMutation, CompleteM365MailboxConnectMutationVariables>({
      query: (variables) => ({ document: CompleteM365MailboxConnectDocument, variables })
    }),
    DisconnectM365Mailbox: build.mutation<DisconnectM365MailboxMutation, DisconnectM365MailboxMutationVariables | void>({
      query: (variables) => ({ document: DisconnectM365MailboxDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCompleteM365MailboxConnectMutation, useDisconnectM365MailboxMutation } = injectedRtkApi;
